import { Card } from '@/components/ui/card'

export function ProfileSkeleton() {
  return (
    <div className="animate-pulse space-y-6">
      <div className="h-4 w-48 rounded bg-cream-2" />
      <div className="grid gap-6 xl:grid-cols-[320px_1fr]">
        <Card className="h-[420px]" />
        <div className="space-y-4">
          <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
            {Array.from({ length: 4 }).map((_, i) => (
              <Card key={i} className="h-24" />
            ))}
          </div>
          <Card className="h-80" />
        </div>
      </div>
    </div>
  )
}
